import Q2_1 from './Q2_1';

export default Q2_1;
